/* HH buy-box plus. Patch layer over the rendered hh-sub-tiers.js DOM — it never
   touches the engine's data, so tier prices stay the single source of truth.
   - Set & Forget perks restyled as the kit-style checked rows (+ 60-day perk reworded)
   - thinner outlines, and every green OUTSIDE the tier tiles recoloured to brand
   - the old "Add N more ..." + gift unlock text replaced by a tier progress bar,
     which since 2 Oct 2026 sits BELOW Add to cart instead of under the size selector
   - collapsible FAQ below that (Set & Forget steps + cost table)
   - sticky-bar box-count chip opening a drawer: Boxes -> Size -> plan LAST -> add
   The Set & Forget / One-time choice always stays the LAST step. */
(function () {
  var root = document.querySelector('[data-hh-tiers]');
  if (!root) return;
  var PAIRS = 25, NAVY = '#1E326C', SKY = '#EAF2FC';
  /* 27 Oct 2026: this layer now runs on every glove. The FAQ and "Your Grip-X order" are
     Grip-X copy, so they stay on Grip-X (HH_TIERS.gx). */
  var GX = !!(window.HH_TIERS && window.HH_TIERS.gx);
  var ORDER = GX ? 'Your Grip-X order' : 'Your order';

  var css = ''
    /* thinner outlines - the engine's 2px borders + drop shadows read as heavy */
    + '.hh-t-card,.hh-t-card.is-on{border-width:1px!important;box-shadow:none!important}'
    + '.hh-t-optbox,.hh-t-optbox.is-on{border-width:1px!important;box-shadow:none!important}'
    + '.hh-t-size{border-width:1px!important;border-color:#DCE3F0!important}'
    + '.hh-t-size.has{border-color:' + NAVY + '!important}'
    + '.hh-t-gpsz{border-width:1px!important}'
    /* breathing room: step 1 -> tiles (margins collapse, so this has to beat the
       step's own 7px), and a tighter gap above Add to cart (another layer already
       sets that one !important, so out-specify it with the element name) */
    + '.hh-tiers .hh-t-list{margin-top:18px}'
    + '.hh-tiers button.hh-t-add{margin-top:13px!important}'
    /* Dawn's own product blocks: the 3 icon badges go entirely, the guarantee
       line is centred and tucked in (its colour is set inline in apply()) */
    + '.product__info-container .icon-with-text{display:none!important}'
    + 'p[data-hh-mbg][data-hh-mbg]{text-align:center!important;margin:2px 0 0!important;line-height:1.35!important}'
    /* greens outside the tiles -> brand */
    + '.hh-t-incl{color:' + NAVY + '!important}.hh-t-incl *{color:inherit!important}'
    + '.hh-t-inclico{color:#fff!important;fill:#fff!important;background:' + NAVY + '!important}'
    + '.hh-t-pill{background:' + NAVY + '!important;color:#fff!important}'
    /* the renew strip and the dropdown's own label are both gone - the option text says it */
    + '.hh-t-renew,.hh-t-flabel{display:none!important}'
    + '.hh-t-gp{border-width:1px!important;border-color:rgba(30,50,108,.35)!important;background:' + SKY + '!important}'
    + '.hh-t-gpfree{color:' + NAVY + '!important}'
    + '.hh-t-gpsz.is-on{background:' + NAVY + '!important;border-color:' + NAVY + '!important;color:#fff!important}'
    + '.hh-t-count{display:none!important}'
    /* The hazard report card is lifted out of its own full-width page section
       and into this column (see report() below). Its own stylesheet switches to
       a 2-column banner at a 750px VIEWPORT - which has nothing to do with the
       ~440px column it now lives in - so put the stacked mobile form back. These
       selectors are (0,2,0) against its (0,1,0), so no !important is needed. */
    + '[data-hh-tiers] .hh-rpt-band{padding:12px 0 0}'
    + '[data-hh-tiers] .hh-rpt{max-width:none;display:block;grid-template-columns:none}'
    + '[data-hh-tiers] .hh-rpt-head{display:block;padding:20px}'
    + '[data-hh-tiers] .hh-rpt-title{font-size:24px;-webkit-text-stroke:.47px currentColor}'
    + '[data-hh-tiers] .hh-rpt-body{display:block;padding:15px 18px 18px}'
    + '[data-hh-tiers] .hh-rpt-lead{font-size:14.5px;line-height:1.5}'
    + '[data-hh-tiers] .hh-rpt-chips{display:grid;grid-template-columns:1fr 1fr;gap:8px}'
    + '[data-hh-tiers] .hh-rpt-chip{font-size:11.5px;padding:6px 12px}'
    + '[data-hh-tiers] .hh-rpt-cta{width:100%;align-self:auto;padding:14px 20px;margin-top:14px}'
    + '[data-hh-tiers] .hh-rpt-src{text-align:left}'
    /* Set & Forget perks, styled like the kit rows. The engine already draws an
       absolutely-positioned circle + tick per row and its selectors are
       .hh-tiers-prefixed, so match that depth or the green wins. */
    + '.hh-tiers .hh-t-perks{gap:8px}'
    + '.hh-tiers .hh-t-perks li{padding-left:25px;font-size:12.5px;line-height:1.45;color:#16234A}'
    + '.hh-tiers .hh-t-perks li b{font-weight:800}'
    + '.hh-tiers .hh-t-perks li::before{width:17px;height:17px;top:1px;background:' + NAVY + '}'
    + '.hh-tiers .hh-t-perks li::after{left:6.1px;top:5px;width:4px;height:7.5px;border-width:0 2px 2px 0}'
    /* FAQ */
    + '.hh-faq{margin:16px 0 0;border-top:1px solid #DCE3F0}'
    + '.hh-faq-i{border-bottom:1px solid #DCE3F0}'
    + '.hh-faq-q{width:100%;background:none;border:0;padding:13px 2px;display:grid;grid-template-columns:1fr 18px;gap:12px;align-items:center;text-align:left;cursor:pointer;font-family:inherit;font-size:13.5px;font-weight:700;color:#16234A;line-height:1.35}'
    + '.hh-faq-q .pm{position:relative;width:18px;height:18px;flex:none}'
    + '.hh-faq-q .pm::before,.hh-faq-q .pm::after{content:"";position:absolute;background:' + NAVY + ';border-radius:2px;transition:transform .2s,opacity .2s}'
    + '.hh-faq-q .pm::before{left:0;top:8px;width:18px;height:2px}'
    + '.hh-faq-q .pm::after{left:8px;top:0;width:2px;height:18px}'
    + '.hh-faq-i.is-open .pm::after{transform:rotate(90deg);opacity:0}'
    + '.hh-faq-a{display:none;padding:0 2px 15px;font-size:13px;line-height:1.55;color:#16234A;font-weight:500}'
    + '.hh-faq-i.is-open .hh-faq-a{display:block}'
    + '.hh-faq-a p{margin:0 0 9px}.hh-faq-a p:last-child{margin-bottom:0}'
    + '.hh-faq-a ul{margin:9px 0;padding-left:17px;display:grid;gap:6px}'
    + '.hh-faq-a li::marker{color:' + NAVY + '}'
    + '.hh-lnk{display:inline-block;margin:4px 10px 0 0;font-weight:800;color:' + NAVY + ';font-size:12.5px}'
    /* Set & Forget 3-step strip (inside FAQ 1) */
    + '.hh-how{border:1px solid #DCE3F0;border-radius:12px;overflow:hidden;margin:2px 0 0}'
    + '.hh-how-r{display:grid;grid-template-columns:78px 1fr;gap:10px;padding:9px 11px;border-top:1px solid #E4E9F3;font-size:12.5px;font-weight:600;color:#16234A;align-items:start}'
    + '.hh-how-r:first-child{border-top:0}'
    + '.hh-how-w{font-size:10.5px;font-weight:800;color:' + NAVY + ';letter-spacing:.06em;text-transform:uppercase;padding-top:2px}'
    /* cost table (inside FAQ 3) */
    + '.hh-ct{width:100%;border-collapse:collapse;font-variant-numeric:tabular-nums;font-size:12.5px;margin:2px 0 8px}'
    + '.hh-ct th,.hh-ct td{padding:7px 5px;text-align:right;border-bottom:1px solid #E4E9F3}'
    + '.hh-ct th:first-child,.hh-ct td:first-child{text-align:left}'
    + '.hh-ct th{font-size:10px;letter-spacing:.07em;text-transform:uppercase;color:#7A85A3;font-weight:800}'
    + '.hh-ct tr.best td{background:' + SKY + ';font-weight:800;color:' + NAVY + '}'
    + '.hh-ct td.rrp{color:#B3BCD1;text-decoration:line-through}'
    + '.hh-ct-note{font-size:11.5px;color:#47536F;font-weight:600}'
    /* sticky chip + drawer */
    /* sticky bar on mobile: same shape as desktop - image, boxes, size, Add to cart. The
       box-count chip is gone (tapping the image still opens the drawer), the image is
       larger, the boxes select keeps its natural width so it never truncates, and the
       button takes whatever is left. Selectors are (0,2,0)/(0,2,1) so they beat the
       engine's single-class rules without !important. */
    + '.hh-sticky-pp{display:none!important}'
    + '@media (max-width:749px){.hh-sticky .hh-sticky-in{gap:6px}.hh-sticky-in img{width:56px;height:56px}.hh-sticky-in .hh-sticky-qty{flex:0 0 auto;max-width:none}.hh-sticky-in .hh-sticky-qty select{width:auto;font-size:13px;padding:10px 28px 10px 10px}.hh-sticky-qty.hh-t-freqwrap:after{right:10px}.hh-sticky .hh-sticky-in .hh-sticky-btn{flex:1 1 auto;white-space:nowrap;padding:14px 10px!important;font-size:12px!important;letter-spacing:.02em}}'
    + '.hh-sticky-in .hh-sticky-btn{padding:14px 14px!important;font-size:13px!important}'
    + '.hh-drawer{position:fixed;inset:0;z-index:9999;display:none;font-family:inherit}'
    + '.hh-drawer.is-open{display:block}'
    + '.hh-dr-bg{position:absolute;inset:0;background:rgba(10,18,40,.45)}'
    + '.hh-dr-sheet{position:absolute;left:0;right:0;bottom:0;background:#fff;border-radius:18px 18px 0 0;padding:12px 16px calc(16px + env(safe-area-inset-bottom,0px));display:grid;gap:8px;max-height:86vh;overflow:auto;box-shadow:0 -20px 40px -20px rgba(23,42,94,.6);color:#16234A}'
    + '.hh-dr-grab{width:44px;height:4px;border-radius:999px;background:#DCE3F0;margin:0 auto 2px}'
    + '.hh-dr-h{font-weight:800;font-size:16px}'
    + '.hh-dr-l{font-size:11px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#47536F;margin-top:4px}'
    + '.hh-dr-tiers{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}'
    + '.hh-dr-t{border:1px solid #DCE3F0;border-radius:12px;background:#fff;padding:8px 4px;display:grid;gap:1px;text-align:center;cursor:pointer;color:#16234A;font-family:inherit}'
    + '.hh-dr-t.is-on{border-color:' + NAVY + ';background:#F7FAFF}'
    + '.hh-dr-t b{font-size:15px}.hh-dr-t span{font-size:12px;font-weight:800;color:' + NAVY + '}.hh-dr-t i{font-style:normal;font-size:10px;font-weight:700;color:#7A85A3}'
    + '.hh-dr-sizes{display:flex;gap:6px}'
    + '.hh-dr-s{flex:1;border:1px solid #DCE3F0;border-radius:10px;background:#fff;padding:9px 0;font-weight:800;font-size:13px;cursor:pointer;color:#16234A;font-family:inherit}'
    + '.hh-dr-s.is-on{background:' + NAVY + ';color:#fff;border-color:' + NAVY + '}'
    + '.hh-dr-plans{display:grid;gap:6px}'
    + '.hh-dr-p{border:1px solid #DCE3F0;border-radius:12px;background:#fff;padding:9px 12px;text-align:left;cursor:pointer;display:grid;gap:1px;color:#16234A;font-family:inherit}'
    + '.hh-dr-p.is-on{border-color:' + NAVY + ';background:' + SKY + ';box-shadow:inset 0 0 0 1px ' + NAVY + '}'
    + '.hh-dr-p b{font-size:13.5px}.hh-dr-p span{font-size:11.5px;color:#47536F;font-weight:600}'
    + '.hh-dr-sum{font-size:13px;font-weight:700;color:#47536F;text-align:center}.hh-dr-sum b{color:' + NAVY + ';font-size:15px}'
    + '.hh-dr-add{border:0;border-radius:999px;background:' + NAVY + ';color:#fff;font-weight:800;text-transform:uppercase;letter-spacing:.04em;font-size:14px;padding:14px;cursor:pointer;font-family:inherit}'
    + '.hh-dr-close{border:0;background:none;color:#47536F;font-weight:700;font-size:12.5px;cursor:pointer;padding:4px;font-family:inherit}'
    + '.hh-dr-lock{overflow:hidden}'
    + '';
  var st = document.createElement('style'); st.id = 'hh-buybox-plus-css'; st.textContent = css; document.head.appendChild(st);

  function money(n) { return '$' + n.toFixed(2); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  /* Idempotent write. innerHTML serialises entities (&rarr; -> →, &mdash; -> —), so a
     raw string compare never matches and the node was rewritten on EVERY apply(),
     which re-fired the MutationObserver below in a permanent 60fps loop (the Chrome
     "Page Unresponsive" freeze). Remember the last string we wrote per node and
     skip when it is unchanged; on first sight compare against a normalised copy. */
  function setHTML(node, html) {
    if (!node || node.hhLast === html) return;
    if (node.hhLast === undefined) {
      var tp = document.createElement('template'); tp.innerHTML = html;
      if (node.innerHTML === tp.innerHTML) { node.hhLast = html; return; }
    }
    node.innerHTML = html; node.hhLast = html;
  }
  function cards() { return root.querySelectorAll('.hh-t-card'); }
  /* "$20.06 per box" on the everyday tiles (25 Oct 2026), "$18.23 /box" on Black November ones */
  function priceOf(c) { var m = (c.textContent || '').match(/\$(\d+(?:\.\d+)?)\s*(?:\/|per)\s*box/i); return m ? parseFloat(m[1]) : NaN; }
  function selCard() { return root.querySelector('.hh-t-card.is-on'); }
  function selQ() { var c = selCard(); return c ? +c.getAttribute('data-q') : 10; }
  /* The real box count (mixed sizes can be 12, between two bundles). The tiers engine
     writes it into [data-hh-count] b. Falls back to the selected bundle. 25 Oct 2026. */
  function totQ() { var b = root.querySelector('[data-hh-count] b'); var n = b ? parseInt(b.textContent, 10) : NaN; return isNaN(n) ? selQ() : n; }
  function mode() { var o = root.querySelector('.hh-t-optbox.is-on'); return o ? o.getAttribute('data-mode') : 'sub'; }
  function weeks() {
    var s = root.querySelector('select[data-hh-freq]'); if (!s) return 8;
    var o = s.options[s.selectedIndex]; var m = ((o && o.textContent) || s.value || '').match(/(\d+)\s*week/i); return m ? +m[1] : 8;
  }
  function rrp() {
    /* Black November: there is no plan card to read, so use the real one-box price */
    if (document.documentElement.classList.contains('hh-bn') && window.HH_BN_TILES) return window.HH_BN_TILES.rrp / 100;
    var s = root.querySelector('.hh-t-opttot s'); var q = selQ();
    var m = s ? (s.textContent || '').match(/([\d.]+)/) : null;
    return m && q ? parseFloat(m[1]) / q : 34.97;
  }

  var busy = false, pending = false;
  function schedule() { if (pending) return; pending = true; window.requestAnimationFrame(function () { pending = false; apply(); }); }

  /* Add to cart sits a shade lighter at rest so the hover visibly darkens it.
     Inline rather than CSS: another PDP layer wins the background at every
     selector weight we tried, and inline !important is the top of the cascade.
     Hover is bound once per element (the engine swaps the node on re-render). */
  var ADD_REST = '#2A4386', ADD_HOVER = '#16274F';
  function paintAdd(b) {
    if (!b) return;
    b.style.setProperty('background', b.hhHover ? ADD_HOVER : ADD_REST, 'important');
    b.style.setProperty('transition', 'background .15s', 'important');
    if (b.hhBound) return;
    b.hhBound = 1;
    b.addEventListener('mouseenter', function () { b.hhHover = 1; paintAdd(b); });
    b.addEventListener('mouseleave', function () { b.hhHover = 0; paintAdd(b); });
  }

  function apply() {
    if (busy) return; busy = true;
    try {
      /* Step labels are NOT patched here any more (2 Oct 2026). This used to rewrite
         "How many boxes?" to "Choose Your Bundle" and "Pick your sizes" to "Build Your
         Box", and to hide step 3 on the grounds that the two plan cards name
         themselves. The owner has since renamed all three in
         sections/hh-sub-tiers.liquid - "Choose your bundle", "Pick your size",
         "Purchase options" - so the old regexes no longer match anything, and the
         step-3 hide would have swallowed a heading he asked for. The section is the
         single source for this copy; edit it there. */
      /* Set & Forget pitch: name the problem, not the feature. Keep it to two lines. */
      var osub = root.querySelector('.hh-t-optbox[data-mode="sub"] .hh-t-optsub');
      if (osub && !/never run out/i.test(osub.textContent)) {
        osub.textContent = 'Never run out. Never overpay for rubbish gloves.';
      }
      /* the label above the dropdown is hidden, so each option has to name itself */
      var fsel = root.querySelector('select[data-hh-freq]');
      if (fsel) Array.prototype.forEach.call(fsel.options, function (o) {
        if (/^\s*Every\s/i.test(o.textContent)) o.textContent = o.textContent.replace(/^\s*Every\s+/i, 'Restock every ');
      });
      var hint = root.querySelector('.hh-t-hint');
      if (hint && /email you 3 days/i.test(hint.textContent)) {
        hint.textContent = 'You’ll be notified by email 3 days before.';
      }
      /* "One-time purchase" -> "One-time Purchase" */
      var oneb = root.querySelector('.hh-t-optbox[data-mode="one"] .hh-t-optmain b');
      if (oneb && /one-time purchase/i.test(oneb.textContent)) {
        var onebT = oneb.textContent.replace(/purchase/i, 'Purchase');
        if (onebT !== oneb.textContent) oneb.textContent = onebT; /* the test stays true after the fix, so guard the write */
      }
      /* the guarantee line keeps its shield emoji in the rich text - strip it */
      var mbg = document.querySelector('[data-hh-mbg]');
      if (mbg && mbg.firstChild && mbg.firstChild.nodeType === 3 && /🛡/.test(mbg.firstChild.nodeValue)) {
        mbg.firstChild.nodeValue = mbg.firstChild.nodeValue.replace(/🛡️?\s*/, '');
      }
      /* colour is the one property another layer keeps winning on this line and on
         Add to cart, at any selector weight - so set it inline, which tops the cascade */
      if (mbg) {
        mbg.style.setProperty('color', '#07692F', 'important');
        Array.prototype.forEach.call(mbg.querySelectorAll('strong,b'), function (s) {
          s.style.setProperty('color', '#07692F', 'important');
        });
      }
      paintAdd(root.querySelector('.hh-t-add'));
      /* Dawn pads the product section 24px at the bottom, which pushes the report
         card away from the guarantee line. Trim it on the element itself - the
         class is template-generated, so there is no stable selector to target. */
      var mainSec = root.closest('.shopify-section');
      var pad = mainSec && mainSec.firstElementChild;
      if (pad && !window.HH_QB_HOME) pad.style.setProperty('padding-bottom', '10px', 'important');
      /* The guarantee row used to be reworded here to "+ 30 days = 60 day money-back
         guarantee". Removed 30 Sep 2026: hh-pdp-tweaks.js now writes the final copy
         for every perk (with the leading word capitalised and bolded), and setting
         textContent on the row's <b> here would have flattened that markup. */
      /* perks: owner's running order, strongest offer first. The engine emits them
         in its own order, so sort the rendered <li>s rather than touching it. */
      var ul = root.querySelector('.hh-t-perks');
      if (ul) {
        /* Free shipping applies to the FIRST order only (30 Sep 2026) and the owner
           wants it called out as the top perk. The engine never emits it, so add it
           here once - guarded by the data attribute so apply() stays idempotent -
           and rank it first in want[] below. */
        if (!ul.querySelector('[data-hh-fs1]')) {
          var fs1 = el('li', '', '<b>Free shipping on your first order</b>');
          fs1.setAttribute('data-hh-fs1', '1');
          ul.insertBefore(fs1, ul.firstChild);
        }
        var want = [
          /first order/i,
          /money[-\s]?back/i,
          /shipping protection/i,
          /locked for life/i,
          /skip,? delay/i
        ];
        var lis = Array.prototype.slice.call(ul.children);
        var rank = function (li) {
          for (var i = 0; i < want.length; i++) if (want[i].test(li.textContent)) return i;
          return want.length;
        };
        var sorted = lis.slice().sort(function (a, b) { return rank(a) - rank(b); });
        var changed = sorted.some(function (li, i) { return li !== lis[i]; });
        if (changed) sorted.forEach(function (li) { ul.appendChild(li); });
      }
      /* The tier progress bar that sat under Add to cart ("10 boxes -> CREW tier unlocked")
         was removed on 25 Oct 2026 (owner): the tiles already say it. The FAQ below now
         anchors straight after the dispatch line. */
      /* FAQ */
      if (GX && !window.HH_QB_HOME) faq();   /* not in the homepage quick buy (4 Nov 2026) */
      /* the report card, above the FAQ */
      report();
      /* sticky chip + drawer */
      sticky();
    } finally {
      /* Records queued by our own writes above would otherwise re-run apply() next frame. */
      if (mo) mo.takeRecords();
      busy = false;
    }
  }

  /* ---------------- hazard report card ----------------
     It ships as its own full-width page section below the product. The owner
     wants it above the FAQ, so lift the whole section into this column, landing
     it between the delivery estimate and the accordion. Moving the section
     element keeps the theme editor working on it; only its position changes.
     Idempotent - it only moves when it is not already sitting where it belongs. */
  function report() {
    /* 25 Oct 2026 (owner's CRO brief, Step 4.3): the Cancerous Chemicals card stays,
       but below the three proof cards (the hh-usp-video section) and never in the buy
       box. It now keeps its own place in the template order, so nothing is lifted. */
    return;
    var box = root.querySelector('.hh-faq');
    var rep = document.querySelector('.shopify-section[id*="hh_report"]');
    if (!box || !rep || rep.nextElementSibling === box) return;
    box.parentNode.insertBefore(rep, box);
  }

  /* ---------------- FAQ ---------------- */
  var FAQ = [
    { q: 'How does Set &amp; Forget work?', a: '<div data-faq-steps></div>' },
    {
      q: 'Are they chemical resistant?',
      a: '<p>Grip-X gloves are resistant to thinner, gunwash, primer and many other solvents &mdash; loved by panel beaters, plumbers, powder coaters, pressure washers and other trades that deal with cancerous chemicals.</p>'
    },
    { q: 'What does Grip-X actually cost me?', a: '<div data-faq-table></div>' },
    {
      q: 'What if they’re not strong?',
      a: '<p>If they aren’t the strongest nitrile gloves you’ve used, reach out to us to claim your 30-Day Money Back Guarantee. We make it risk free for you to try Australia’s strongest with confidence.</p>'
    },
    {
      q: 'Beware of cheap, poorly made copies',
      a: '<p>As Grip-X has grown in popularity, we’ve seen more and more look-alike gloves appear online. A diamond texture and a black box tell you nothing about what is actually in the nitrile.</p>'
        + '<p><b>Before you buy any heavy-duty glove, ask for:</b></p>'
        + '<ul><li>The <b>measured thickness</b> &mdash; fingertip and palm, in mil or mm, not a vague &ldquo;extra thick&rdquo;.</li>'
        + '<li>A <b>data sheet for the exact glove being sold</b>, not the factory’s generic specs.</li>'
        + '<li>Proof it is <b>certified for use in Australia</b> &mdash; an ARTG number you can look up yourself.</li></ul>'
        + '<p>We publish all three. Grip-X measures <b>0.25mm minimum &plusmn;0.02mm at the fingertip (about 10 mil)</b>, conforms to <b>ASTM D6319</b>, and is listed on the TGA’s ARTG under <b>448462</b> &mdash; a public register anyone can search.</p>'
        + '<p><a class="hh-lnk" href="https://cdn.shopify.com/s/files/1/0862/5786/0895/files/Grip_X_Flyer_compressed_4c1069e5-3417-4d42-8860-3fceb60c75b9.pdf?v=1733547270" target="_blank" rel="noopener">Read the Grip-X data sheet (PDF) &rarr;</a>'
        + '<a class="hh-lnk" href="https://www.tga.gov.au/resources/artg/448462" target="_blank" rel="noopener">Check ARTG 448462 &rarr;</a></p>'
        + '<p>When a glove is the only thing between your skin and the chemicals, look past the photo. Check the numbers.</p>'
    }
  ];

  function faq() {
    var add = root.querySelector('.hh-t-add'); if (!add) return;
    var box = root.querySelector('.hh-faq');
    if (!box) {
      box = el('div', 'hh-faq');
      FAQ.forEach(function (f, i) {
        var item = el('div', 'hh-faq-i');
        /* the Set & Forget answer - hidden while Black November is live (assets/hh-bn.css) */
        if (i === 0) item.setAttribute('data-hh-faq-sf', '1');
        item.innerHTML = '<button type="button" class="hh-faq-q" aria-expanded="false"><span>' + f.q + '</span><span class="pm" aria-hidden="true"></span></button>'
          + '<div class="hh-faq-a">' + f.a + '</div>';
        item.querySelector('.hh-faq-q').addEventListener('click', function (e) {
          var open = item.classList.toggle('is-open');
          e.currentTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        box.appendChild(item);
      });
      /* After the tier progress bar, which itself sits under the dispatch line below
         Add to cart (2 Oct 2026). Anchoring on the button instead would wedge the
         whole accordion between the CTA and the bar. report() then lifts the hazard
         section in just above this box, so the column reads
         CTA -> dispatch -> tier bar -> report -> FAQ. */
      var fanchor = root.querySelector('.hh-t-dispatch') || add;
      fanchor.insertAdjacentElement('afterend', box);
    }
    /* dynamic answers */
    var q = totQ(), w = weeks(), g = q >= 20 ? ' and both free boxes' : q >= 10 ? ' and your free box' : '';
    setHTML(box.querySelector('[data-faq-steps]'),
      '<div class="hh-how">'
      + '<div class="hh-how-r"><span class="hh-how-w">Today</span><span>Your ' + q + ' boxes' + g + ' ship within 1&ndash;2 business days.</span></div>'
      + '<div class="hh-how-r"><span class="hh-how-w">In ' + w + ' weeks</span><span>Fresh boxes land before you run out. You&rsquo;ll be notified by email 3 days before, so you can skip it if the shed is still full.</span></div>'
      + '<div class="hh-how-r"><span class="hh-how-w">Any time</span><span>Skip, push back or stop in one tap. No calls, no forms, and your price is locked for life.</span></div>'
      + '</div>');
    var base = rrp(), rows = '';
    rows += '<tr><td>RRP</td><td class="rrp">' + money(base / PAIRS) + '</td><td class="rrp">' + money(base / PAIRS * 3) + '</td><td class="rrp">' + money(base / PAIRS * 15) + '</td></tr>';
    Array.prototype.forEach.call(cards(), function (c) {
      var p = priceOf(c), cq = c.getAttribute('data-q'); if (!p) return;
      rows += '<tr' + (c.classList.contains('is-on') ? ' class="best"' : '') + '><td>' + cq + ' boxes</td><td>' + money(p / PAIRS) + '</td><td>' + money(p / PAIRS * 3) + '</td><td>' + money(p / PAIRS * 15) + '</td></tr>';
    });
    setHTML(box.querySelector('[data-faq-table]'),
      '<table class="hh-ct"><thead><tr><th>Boxes</th><th>Per pair</th><th>Per day*</th><th>Per week</th></tr></thead><tbody>' + rows + '</tbody></table>'
      + '<p class="hh-ct-note">*One pair per job, three jobs a day, five days a week. One box is 50 gloves &mdash; 25 pairs.</p>');
  }

  /* ---------------- sticky chip + drawer ---------------- */
  var drawer = null;
  function sticky() {
    var bar = document.querySelector('.hh-sticky-in'); if (!bar) return;
    /* Owner (2026-09-29): the mobile bar is image + boxes + size + Add to cart, same as
       desktop. No box-count chip; tapping the product image still opens the drawer. */
    var old = bar.querySelector('.hh-sticky-pp'); if (old) old.remove();
    var img = bar.querySelector('img');
    if (img && !img.hhDrawer) { img.hhDrawer = 1; img.style.cursor = 'pointer'; img.addEventListener('click', openDrawer); }
    /* "10 boxes" -> "10 Boxes" in the sticky select. Write only when it differs. */
    var qs = bar.querySelector('select[data-hh-stickyqty]');
    if (qs) Array.prototype.forEach.call(qs.options, function (o) {
      var t = o.textContent.replace(/\b(\d+)\s+box(es)?\b/i, function (_, n, es) { return n + ' Box' + (es ? 'es' : ''); });
      if (t !== o.textContent) o.textContent = t;
    });
    if (drawer && drawer.classList.contains('is-open')) paintDrawer();
  }
  function buildDrawer() {
    drawer = el('div', 'hh-drawer');
    drawer.innerHTML = '<div class="hh-dr-bg" data-close></div><div class="hh-dr-sheet" role="dialog" aria-label="' + ORDER + '">'
      + '<div class="hh-dr-grab"></div><div class="hh-dr-h">' + ORDER + '</div>'
      + '<div class="hh-dr-l">Boxes</div><div class="hh-dr-tiers" data-dtiers></div>'
      + '<div class="hh-dr-l">Size</div><div class="hh-dr-sizes" data-dsizes></div>'
      + '<div class="hh-dr-l" data-hh-drplans>How would you like to buy?</div><div class="hh-dr-plans" data-dplans></div>'
      + '<div class="hh-dr-sum" data-dsum></div>'
      + '<button type="button" class="hh-dr-add" data-dadd>Add to cart</button>'
      + '<button type="button" class="hh-dr-close" data-close>Close</button></div>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-close]')) { closeDrawer(); return; }
      var b = t.closest('[data-dq]'); if (b) { var c = root.querySelector('.hh-t-card[data-q="' + b.getAttribute('data-dq') + '"]'); if (c) c.click(); return; }
      var s = t.closest('[data-dsz]'); if (s) { var z = root.querySelector('.hh-t-size[data-sz="' + s.getAttribute('data-dsz') + '"]'); if (z) (z.querySelector('.hh-t-sizename') || z).click(); return; }
      var p = t.closest('[data-dmode]'); if (p) { var o = root.querySelector('.hh-t-optbox[data-mode="' + p.getAttribute('data-dmode') + '"] .hh-t-opt'); if (o) o.click(); return; }
      if (t.closest('[data-dadd]')) { closeDrawer(); var a = root.querySelector('.hh-t-add'); if (a) a.click(); return; }
    });
  }
  function paintDrawer() {
    var tiers = '';
    Array.prototype.forEach.call(cards(), function (c) {
      var q = c.getAttribute('data-q'), p = priceOf(c);
      tiers += '<button type="button" class="hh-dr-t' + (c.classList.contains('is-on') ? ' is-on' : '') + '" data-dq="' + q + '"><b>' + q + '</b><span>' + (p ? money(p) : '') + '</span><i>a box</i></button>';
    });
    setHTML(drawer.querySelector('[data-dtiers]'), tiers);
    var sizes = '';
    Array.prototype.forEach.call(root.querySelectorAll('.hh-t-size'), function (z) {
      var n = z.querySelector('.hh-t-sizename');
      sizes += '<button type="button" class="hh-dr-s' + (z.classList.contains('has') ? ' is-on' : '') + '" data-dsz="' + z.getAttribute('data-sz') + '">' + (n ? n.textContent : '') + '</button>';
    });
    setHTML(drawer.querySelector('[data-dsizes]'), sizes);
    var m = mode();
    setHTML(drawer.querySelector('[data-dplans]'),
      /* no Set & Forget option on the page (no Appstle plan) -> no Set & Forget button */
      (!root.querySelector('.hh-t-optbox[data-mode="sub"]') ? '' : '<button type="button" class="hh-dr-p' + (m === 'sub' ? ' is-on' : '') + '" data-dmode="sub"><b>Set &amp; Forget</b><span>Save 18% more &middot; skip or stop any time</span></button>')
      + '<button type="button" class="hh-dr-p' + (m === 'one' ? ' is-on' : '') + '" data-dmode="one"><b>One-time Purchase</b></button>');
    var txt = (root.querySelector('[data-hh-addtxt]') || {}).textContent || ''; var mm = txt.match(/\$[\d.,]+/);
    setHTML(drawer.querySelector('[data-dsum]'), mm ? '<b>' + mm[0] + '</b>' : '');
  }
  function openDrawer() { if (!drawer) buildDrawer(); paintDrawer(); drawer.classList.add('is-open'); document.documentElement.classList.add('hh-dr-lock'); }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.documentElement.classList.remove('hh-dr-lock'); } }

  var mo = new MutationObserver(function () { if (!busy) schedule(); });
  mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  root.addEventListener('change', schedule);
  var tries = 0, t = setInterval(function () { if (document.querySelector('.hh-sticky-in') || ++tries > 40) { clearInterval(t); schedule(); } }, 500);
  apply();
})();